<template>
  <app-modal modal-id="warehouse-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_warehouse_item") : $t("add_warehouse_item") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/warehouse-items`">
        <div class="form-group mb-4" v-if="!warehouse">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("warehouse_item_name") }}</label>
            </div>
            <div class="col-sm-7">
              {{formData.warehouse.name}}
            </div>
          </div>
        </div>
        <div class="form-group mb-4" v-if="!type">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("warehouse_type_list") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                 
                  type="select"
                  list-value-field="name"
                  :list="warehouseTypeListItem"
                  :placeholder="$t('choose_an_warehouse_type')"
                  v-model="formData.type_id"
                  :error-message="$errorMessage(errors, 'warehouse_type_id')"
                  :disabled="type ? true : false"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("warehouse_qty") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="number"
                  :placeholder="$t('enter_number_qty')"
                  name="name"
                  v-model="formData.qty"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4" v-if="optionPrice">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("price_sum") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="number"
                  :placeholder="$t('enter_price_sum')"
                  name="name"
                  v-model="formData.price"
                  :error-message="$errorMessage(errors, 'price')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("warehouse_descriptions") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="text"
                  :placeholder="$t('enter_warehouse_descriptions')"
                  name="name"
                  v-model="formData.descriptions"
                  :error-message="$errorMessage(errors, 'descriptions')"
              />
            </div>
          </div>
        </div>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";

export default {
  name: "WarehouseModal",
  mixins: [FormSubmitMixin],
  props: ["type","warehouse"],
  data() {
    return {
      isOrganizationModalActive: false,
      addMoreDetails: false,
      dataLoaded: true,
      countryList: [],
      formData: {
        owner_id: user.id, 
        warehouse: {
            name: '',
        },
    },
      addEditData: {},
      warehouseTypeListItem: [
        {
            id: 1,
            name: this.$t('warehouse_1')
        },
        {
            id: 2,
            name: this.$t('warehouse_2')
        },
        {
            id: 3,
            name: this.$t('warehouse_3')
        },
      ],
    };
  },
  computed: {
    ...mapGetters({

    }),

    optionPrice(){
      if(this.type){
        return (this.type == 2) ? false : true;
      }else{
        return (this.formData.type_id == 2) ? false : true;
      }
    }
    

  },
  methods: {
  
   
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
		this.addEditData.qty = this.formData.qty;
		this.addEditData.descriptions = this.formData.descriptions;
		this.addEditData.owner_id = this.formData.owner_id;
    if(this.formData.type_id == 2){
      this.addEditData.price = 0;
    }else{
      this.addEditData.price = this.formData.price;
    }

    if(this.warehouse > 0){
      this.addEditData.warehouse_id = this.warehouse;
    }else{
      this.addEditData.warehouse_id = this.formData.warehouse_id;
    }
    if(this.type > 0){
      this.addEditData.type_id = this.type;
    }else{
      this.addEditData.type_id = this.formData.type_id;
    }
      
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
   
    },
   
  },
  mounted() {

  },
  created(){
   
  }
};
</script>
